import { Link } from 'react-router-dom';
import { useGetContactsStore } from '@lib/store';
import { RoutePaths } from '@shared/utils';
import { ButtonV2 } from '@shared/widgets';

export const RecoveryResetUsernameForm = () => {
  const { data } = useGetContactsStore();

  return (
    <>
      <div className='mb-6 text-center text-sm text-[#fcfcfc] uppercase'>Recover username</div>
      <div>
        <div className='relative w-full text-center uppercase'>
          <div className='flex h-[125px] w-[330px] items-center justify-center rounded-sm bg-[#1f1f1f] object-contain px-5 text-center text-sm font-medium text-[#929292] shadow-[12px_12px_24px_0_#0000003b]'>
            <p>
              Please, contact customer service to recover your access using this phone <span className='text-[#fcfcfc]'>{data?.Phone1}</span>
            </p>
          </div>
        </div>
        <Link to={RoutePaths.recovery.onNavigate()}>
          <ButtonV2 className='mt-7.5 !h-[56px]' color='outlined' fullWidth>
            Cancel
          </ButtonV2>
        </Link>
      </div>
    </>
  );
};
